// landing/ShelbulaLogo.jsx
import React from 'react';

/* ========================
 * ShelbulaLogo - Renders the Shelbula logo with cat icon and text
 * Accepts a size prop ('default' or 'large')
 * ========================*/
const ShelbulaLogo = ({ size = 'default' }) => {
  // Current logic makes both sizes render the same, kept for potential future differentiation
  const logoSize = size === 'large' ? 'h-7 w-7' : 'h-7 w-7'; 
  const textSize = size === 'large' ? 'text-2xl' : 'text-2xl';
  
  return (
    <div className="flex items-center">
      <div className="relative">
        <div className={`absolute inset-0 bg-gradient-to-br from-orange-500 to-amber-500 rounded-full opacity-20 blur-md`}></div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`${logoSize} text-orange-500 relative`}
        >
          <path d="M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3.1-9-7.56c0-1.2.43-2.37 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z"/>
          <path d="M8 14v.5" />
          <path d="M16 14v.5" />
          <path d="M11.25 16.25h1.5L12 17l-.75-.75Z" />
        </svg>
      </div>
      <span className={`${textSize} font-bold ml-2 bg-gradient-to-r from-orange-500 to-amber-500 bg-clip-text text-transparent`}>Shelbula</span>
    </div>
  );
};

export default ShelbulaLogo;